import { render, staticRenderFns } from "./LpAdmDropDepthInput.vue?vue&type=template&id=36f88478&scoped=true"
import script from "./LpAdmDropDepthInput.vue?vue&type=script&lang=js"
export * from "./LpAdmDropDepthInput.vue?vue&type=script&lang=js"
import style0 from "./LpAdmDropDepthInput.vue?vue&type=style&index=0&id=36f88478&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f88478",
  null
  
)

export default component.exports